export class StockSocketTransferDTO {
    stockId: string | undefined;
    showTrendChart: boolean | undefined;

    constructor(stockId: string, showTrendChart: boolean = false) {
        this.stockId = stockId;
        this.showTrendChart = showTrendChart;
    }
}